export default __webpack_public_path__ + "19acf4ad0d2afd7d71b70cd8a6da8719.gif";